import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash.debounce';
import cn from 'classnames';
import React, { useCallback, useState } from 'react';
import ExecutionEnvironment from 'exenv';

import FederatedLoginModal from 'components/account/FederatedLoginModal';
import useEffectOnce from 'hooks/useEffectOnce';
import { fetchFollowCount, fetchFollowStatus, updateFollowStatus } from 'actions/influencer/influencerFollowers';
import { isAssigned, triggerAssignment } from 'actions/ab';
import { HYDRA_FOLLOW } from 'constants/hydraTests';

import css from 'styles/components/influencer/shoppablePosts/FollowButton.scss';

interface Props {
  style: string;
  iconStyle: string;
  showFollowersCount?: boolean;
}
export const FollowButton = (props: Props) => {
  const { style, iconStyle, showFollowersCount = false } = props;

  const { influencerId } = useSelector(state => state.influencer) || {};
  const { customerFollowedStatus: followStatus, influencerFollowersCount: followersCount } = useSelector(state => state.influencer.followContent);
  const isFollowAllowed = useSelector(state => isAssigned(HYDRA_FOLLOW, 1, state));
  const xMain = useSelector(state => state.cookies?.['x-main']);

  const dispatch = useDispatch();

  const isCustomer = !!(ExecutionEnvironment.canUseDOM && xMain);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
  const handleClose = () => {
    setIsLoginModalOpen(false);
  };

  const onFollowButtonClicked = () => {
    if (isCustomer) {
      dispatch(updateFollowStatus(influencerId, followStatus));
    } else {
      setIsLoginModalOpen(true);
    }
  };

  const debouncedChangeHandler = useCallback(debounce(onFollowButtonClicked, 500), [followStatus, followersCount]);

  useEffectOnce(() => {
    dispatch(fetchFollowStatus(influencerId));
    dispatch(fetchFollowCount(influencerId));
    triggerAssignment(HYDRA_FOLLOW);
  });

  return (
    isFollowAllowed && (
      <div className={css.followButton}>
        <button type="button" onClick={debouncedChangeHandler} className={cn(style, { [iconStyle]: !followStatus })}>
          <span className={css.textStyle}> {followStatus ? 'Following' : 'Follow'}</span>
        </button>
        {showFollowersCount && <span className={css.followCount}>{followersCount} Followers</span>}
        {isLoginModalOpen && <FederatedLoginModal isOpen={isLoginModalOpen} handleClose={handleClose} copy="" returnTo="" />}
      </div>
    )
  );
};
